var map = {
	"./modules/convocatorias/convocatorias.module": [
		"../../../../../src/app/modules/convocatorias/convocatorias.module.ts"
	],
	"./modules/expedientes/expedientes.module": [
		"../../../../../src/app/modules/expedientes/expedientes.module.ts"
	],
	"./modules/titulos/titulos.module": [
		"../../../../../src/app/modules/titulos/titulos.module.ts",
		"titulos.module"
	],
	"./views/dashboard/dashboard.module": [
		"../../../../../src/app/views/dashboard/dashboard.module.ts",
		"dashboard.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /app/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main